import React, { useState } from 'react';
import APopover from '../../views/pages/manage/common/a-popover';
import AButton from '../../views/pages/manage/common/form-fields-mui/AButton';
import { downloadTemplate } from './utils';
import { ReactComponent as DownloadIcon } from "assets/img/svg/fi_download.svg";
import { ReactComponent as ExcelIcon } from "assets/img/svg/excel.svg";
import ALoader from '../../views/pages/manage/common/a-loader';
import { ReactComponent as DownloadIconBlack } from "assets/img/svg/downloadBlack.svg";


const DownloadTemplate = ({
    permittedBulkPaymentTransferTypes,
    setLoading
}) => {
        const downloadClickHandler = async () => {
        try {
            setLoading(true);
            await downloadTemplate(permittedBulkPaymentTransferTypes?.value);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);

        }
    }
    return (

                <AButton
                    variant='outline'
                    size='xs'
                    onClick={downloadClickHandler}
                    outlineVariantColor={"#bfbfbf"}
                    textColor={"#000"}
                >
                    <DownloadIconBlack className='mr-2' />
                    Download Template
                </AButton>

    );
}

export default DownloadTemplate;